﻿import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService } from "../../services/dataService";
import { ValidationBase } from "../../validation/validationBase";
import { ValidationMessage } from "../../validation/validationMessage";
import { ValidationMessageType } from "../../validation/validationMessageType";
import { EmailValidator } from "../../validation/validators/emailValidator";
import { ValidatorTuple } from "../../validation/validators/iValidator";
import { Role } from "src/app/models/role.model";
import { Gender } from "src/app/models/gender.model";

@Component({
  selector: "jax-extlogin",
  templateUrl: "./extLoginForm.component.html",
  host: { "(document: keyup)": "keyup($event)" }
})
export class ExternalLoginComponent extends ValidationBase implements OnInit {
  public firstName: string;
  public lastName: string;
  public emailId: string;
  public token: string;

  public step: number = 1;
  public recoveryOption = 1;
  public invalidUser: boolean = false;
  public isAnswersValid: boolean = true;

  public validators = [];
  public iNotifyError;
  public hasSuccess: boolean = false;
  public validationMessage: ValidationMessage;
  public questionsAnswers: any;
  public genders: any;
  public relationships: any;

  public msgType = ValidationMessageType;
  public errorType: number;

  public username: string;

  constructor(private dataService: DataService, private router: Router, private activateRoute: ActivatedRoute) {
    super();
    this.iNotifyError = this;
    this.validators.push(new ValidatorTuple(new EmailValidator(), this));
    this.hasSuccess = false;
  }

  public ngOnInit() {
    this.activateRoute.queryParams.subscribe(params => {
      this.token = params["id"];

      if (this.token) {
        return this.verifyToken(this.token);
      }
    });
  }

  public verifyToken(token: string): void {
    this.questionsAnswers = "";
    let msg = new ValidationMessage();
    this.dataService.post("common/tokenverfication", JSON.stringify(token)).subscribe(resp => {
      this.hasSuccess = false;
      if (resp.Succeeded != 1) {
        this.hasSuccess = true;
        msg.message = resp.Message;
        msg.messageType = ValidationMessageType.Error;
        this.validationMessage = msg;
        this.errorType = 2;
      }
    });

    this.GetGender();
    this.GetParentRoles();

    this.questionsAnswers = {
      token: this.token,
      firstName: "",
      lastName: "",
      dob: "",
      gender: -1,
      casenumber: "",
      relationship: -1
    };
  }

  public signin() {
    this.router.navigate(["login"]);
  }

  public login() {
    this.validate().subscribe(s => {
      if (!this.isValid || !this.checkQuestionSelected()) {
        return;
      }

      this.validationMessage = null;
      let msg = new ValidationMessage();
      this.dataService.post("extuser/login", JSON.stringify(this.questionsAnswers)).subscribe(resp => {
        this.errorType = resp.Succeeded;
        if (resp && resp.Succeeded == 1) {
          let ret = this.saveUser(resp);
          this.hasSuccess = true;
          msg.messageType = ValidationMessageType.Ok;
          msg.message = resp.Message;
          //  setTimeout(() => {
          this.router.navigate(["dashboard"]);
          //  }, 5000);
        } else {
          this.hasSuccess = false;
          //msg.message = "One or more of your answers is not correct. Please enter your answers again.";
          msg.message = resp.Message;
          msg.messageType = ValidationMessageType.Error;
        }
        this.validationMessage = msg;
      });
    });
  }

  public checkQuestionSelected() {
    let ans1 = this.questionsAnswers.firstName ? 1 : 0;
    let ans2 = this.questionsAnswers.lastName ? 1 : 0;
    let ans3 = this.questionsAnswers.dob ? 1 : 0;
    let ans4 = this.questionsAnswers.gender ? 1 : 0;
    let ans5 = this.questionsAnswers.casenumber ? 1 : 0;
    let ans6 = this.questionsAnswers.relationship ? 1 : 0;

    if (ans1 + ans2 + ans3 + ans4 + ans5 + ans6 >= 5) {
      return true;
    } else {
      let msg = new ValidationMessage();
      msg.messageType = ValidationMessageType.Error;
      msg.message = "Must answer 5 out of 6 questions.";
      this.validationMessage = msg;
      this.errorType = 2;
      return false;
    }
  }

  public validateDropdown($event: any): void {
    let e = $event;
  }

  private saveUser(response: any): boolean {
    let user = response;
    if (user && user.Token) {
      localStorage.setItem("currentUser", JSON.stringify(user));
      return true;
    } else {
      return false;
    }
  }

  private keyup(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.login();
    }
  }

  private GetParentRoles() {
    this.dataService.get("common/parentroles").subscribe(resp => {
      this.relationships = resp;
      this.relationships.unshift(new Role());
      this.questionsAnswers.relationship = "-1";
    });
  }

  private GetGender() {
    this.dataService.get("common/genders").subscribe(resp => {
      this.genders = resp;
      this.genders.unshift(new Gender());
      this.questionsAnswers.gender = "-1";
    });
  }
  
}
